
export default {
  pagination:{
    total: 0,
    currentPage: 1,
    start: 0,
    limit: 20,
  }
}



// WEBPACK FOOTER //
// ./src/common/config.js